import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-operation-note-document-item',
  templateUrl: './operation-note-document-item.component.html',
  styleUrls: ['./operation-note-document-item.component.scss']
})
export class OperationNoteDocumentItemComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
